import request from 'local_modules/request'
import moment from 'moment'
import { getState, reducers } from 'redux/core'
import { constants, array, modals, requestWithMock } from 'helpers'
import actions from 'redux/actions'


const modifyDrivers = (drivers) => {
  const left  = []
  const right = []

  const getFIO = (data) => {
    if (data) {
      if (data.middleName && data.firstName) {
        return `${data.lastName} ${data.firstName[0]}.${data.middleName[0]}.`
      }

      return data.lastName
    }

    return ''
  }

  drivers[0] && drivers[0].driverScheduleList.forEach(({ driverData, readyType, shiftType }, index) => {
    left.push([
      driverData.busGarageNumber,
      driverData.personalNumber,
      getFIO(driverData),
      // driverData.lastName,
      driverData.brigadeId,
    ])

    right.push(
      // drivers.map(({ driverScheduleList }) => shiftValues[driverScheduleList[index].shiftType.shift])
      drivers.map(({ driverScheduleList }) => driverScheduleList[index].shiftType.shift)
    )
  })

  return {
    values: {
      left,
      right,
    },
    headings: drivers.map(({ date }) => date.replace(/.+-/, '')),
    list: drivers[0] ? drivers[0].driverScheduleList.map(({ driverData }) => driverData) : [],
  }
}

const modifyConductors = (conductors) => {
  const left  = []
  const right = []

  conductors[0] && conductors[0].conductorScheduleList.forEach(({ conductorData, readyType, shiftType }, index) => {
    left.push([
      conductorData.busGarageNumber,
      conductorData.personalNumber,
      // `${conductorData.lastName} ${conductorData.firstName} ${conductorData.middleName}`
      conductorData.lastName,
      conductorData.brigadeId,
    ])

    right.push(
      // conductors.map(({ conductorScheduleList }) => shiftValues[conductorScheduleList[index].shiftType.shift])
      conductors.map(({ conductorScheduleList }) => conductorScheduleList[index].shiftType.shift)
    )
  })

  return {
    values: {
      left,
      right,
    },
    headings: conductors.map(({ date }) => date.replace(/.+-/, '')),
    list: conductors[0] ? conductors[0].conductorScheduleList.map(({ conductorData }) => conductorData) : [],
  }
}

const modifyBuses = (buses) => {
  const left  = []
  const right = []

  buses[0] && buses[0].busTechAvailabilityList.forEach(({ busData, busConditionType }, index) => {
    left.push([
      busData.garageNumber,
      // '',
      // '',
      // '',
      // '№ авт.',
      // 'Гаражный №',
      // 'Марка',
    ])

    right.push(
      buses.map(({ busTechAvailabilityList }) => busTechAvailabilityList[index].busConditionType[0]) // first char
    )
  })

  return {
    values: {
      left,
      right,
    },
    headings: buses.map(({ date }) => date.replace(/.+-/, '').replace(/^0/, '')),
    list: buses[0] ? buses[0].busTechAvailabilityList.map(({ busData }) => busData) : [],
  }
}

const modifyOrder = (order) => {
  const left  = []
  const right = []

  let maxRoutes = 0

  order.fixedShiftDataList.forEach(({ conductorData, driverData, routeName, shiftDepartureList, scheduleType }, index) => {
    left.push([
      `${driverData.lastName || ''} ${driverData.firstName ? driverData.firstName[0] : driverData.firstName || ''} ${driverData.middleName ? driverData.middleName[0] : driverData.middleName || ''}`,
      driverData.personalNumber,
      scheduleType, // Тип расписания
      routeName.replace(/маршрут /, ''),
    ])

    right.push(
      shiftDepartureList.map(({ startTime }) => startTime)
    )

    if (shiftDepartureList.length > maxRoutes) {
      maxRoutes = shiftDepartureList.length
    }
  })

  const headings = array.range(1, maxRoutes).map((count) =>
    count === 1
      ? `<span>Рейсы:</span> <span>${count}</span>`
      : count
  )

  return {
    values: {
      left,
      right: right.map((items) => headings.map((item, index) => items[index] || ' ' )),
    },
    headings,
  }
}

const fetchCodes = ({ type }) => (
  requestWithMock(constants.lscSchedules[`${type}ScheduleCodes`])
    .then(({ data }) => {
      reducers.lscSchedules.schedule.setCodes({ type, data })
    })
)

const fetch = ({ type, date }) => {
  const { lscSchedules: { schedule: { [type]: { limit, values }, codes } } } = getState()

  if (!codes[type]) {
    fetchCodes({ type })
  }

  const modifyResult = ({
    drivers: modifyDrivers,
    conductors: modifyConductors,
    buses: modifyBuses,
    order:  modifyOrder,
    report: (data) => {
      return { data, headings: [], values: { left: [], right: [] } }
    },
  })[type]

  const momentDate = moment(date, 'DD.MM.YYYY')

  reducers.lscSchedules.schedule.setFetching({ type, isFetching: true })

  const query = type === 'order'
    ? `date=${momentDate.format('YYYY-MM-DD')}`
    : `dateMin=${momentDate.format('YYYY-MM-DD')}&dateMax=${
      moment([
        momentDate.format('YYYY'),
        momentDate.format('MM') - 1,
      ]).endOf('month').format('YYYY-MM-DD')
      }
    `

  return requestWithMock(constants.lscSchedules[`${type}Schedule`] + `?${query}`)
    .then(({ data }) => {
      const { values, headings, list } = modifyResult(data)

      if (type !== 'order') {
        reducers.lscSchedules.schedule.setFetching({ type, isFetching: false })
      }

      reducers.lscSchedules.schedule.setHeadings({ type, headings })
      reducers.lscSchedules.schedule.setValues({ type, values })
      reducers.lscSchedules.schedule.setList({ type, list })
      reducers.lscSchedules.schedule.setPages({ type, pages: Math.ceil(values.right.length / limit) })
    })
    .catch((error) => {
      reducers.lscSchedules.schedule.setFetching({ type, isFetching: false })
    })
}

const set = ({ type, id, code, date }) => {
  const endpoint = ({
    buses: constants.lscSchedules.busesScheduleSet,
    drivers: constants.lscSchedules.driversScheduleSet,
    conductors: constants.lscSchedules.conductorsScheduleSet,
  })[type]

  console.log({ type, endpoint, id, code, date })

  return request.post(endpoint, {
    id,
    code,
    dateMin: moment(date).format('YYYY-MM-DD'),
    dateMax: moment(date).format('YYYY-MM-DD'),
  })
    .then(({ data }) => {
      console.log(data)
    })
}

const fetchOldOrder = (date) => {
  const { lscSchedules: { schedule: { order: { limit, values }, codes } } } = getState()

  const momentDate = moment(date, 'DD.MM.YYYY')

  return requestWithMock(constants.lscSchedules.orderScheduleOld + `date=${momentDate.format('YYYY-MM-DD')}`)
    .then(({ data }) => {
      const { values, headings } = modifyOrder(data)

      reducers.lscSchedules.schedule.setHeadings({ type: 'order', headings })
      reducers.lscSchedules.schedule.setValues({ type: 'order', values })
      reducers.lscSchedules.schedule.setPages({ type: 'order', pages: Math.ceil(values.right.length / limit) })
    })
}

const fetchNewOrder = ({ date }) => {
  const { lscSchedules: { schedule: { order: { limit, values }, codes } } } = getState()

  const momentDate = moment(date, 'DD.MM.YYYY')

  reducers.lscSchedules.schedule.setFetching({ type: 'order' })

  return requestWithMock(constants.lscSchedules.orderSchedule + `?date=${momentDate.format('YYYY-MM-DD')}`)
    .then(({ data }) => {
      reducers.lscSchedules.schedule.setFetching({ type: 'order' })
      reducers.lscSchedules.schedule.setNewOrder(data)
      reducers.lscSchedules.schedule.setPages({ type: 'order', pages: Math.ceil(values.right.length / limit) })
    })
}

const setActivePageId = ({ type, activePageId }) => {
  reducers.lscSchedules.schedule.setActivePageId({ type, activePageId })
}

const generateOrder = ({ date, empty }) => {
  actions.ui.showRequestLoader()

  return request.post(constants.lscSchedules.generateOrder, {
    date: moment(date).format('YYYY-MM-DD'),
    dayType: 'auto',
    empty,
  })
    .then(({ data }) => {
      const { successMessage } = data

      Promise.all([
        actions.schedule.fetchNewOrder({ type: 'order', date }),
        actions.report.getGenerationOrderStatus(date)
      ])
        .then(() => {
          actions.ui.hideRequestLoader()
          actions.modals.open(modals.Dialog, {
            text: successMessage,
          })
        })
    })
    .catch(() => actions.ui.hideRequestLoader())
}


export default {
  set,
  fetch,
  fetchNewOrder,
  fetchOldOrder,
  setActivePageId,
  generateOrder,
}
